import { IDTypeEnum } from '../../models/enum/id-type.enum';
import { MaritalStatusEnum } from '../../models/enum/marital-status.enum';
import { idTypesInterface } from '../../utils/shared-dropdown';
import { P2TextInput } from 'react-bootstrap-common-script';
import { Dropdown } from '../dropdown';

function SpouseForm({...props}:any) {
  let placeholder = "Key in your ID here";
  if(props.item?.spouse_id_type === IDTypeEnum.uinfin){
    placeholder = "e.g. S9999999X; T9999999X";
  }
  else if(props.item?.spouse_id_type === IDTypeEnum.foreign_id){
    placeholder = "e.g. F9999999X; G9999999X; M9999999X";
  }

  const handleDropdownChange = (value:any) => {
    props.handleValueChange(value, "spouse_id_type");
  }

  const handleSpouseIdChange = (value:any) => {
    props.handleValueChange(value?.toUpperCase(), "spouse");
  }

  return <>
    {props.item?.myinfo?.marital_status === MaritalStatusEnum.married && <>
        <div style={{ marginTop: 24 }}>
          <Dropdown forceError={props.forceError} disabled={props.disableFields} required selectedDropdown={props.item?.spouse_id_type} placeholder="Please select identification type" label={`Select identification type for ${props.item.myinfo.name}'s spouse`} items={idTypesInterface} setSelectedDropdown={handleDropdownChange}
        />
        </div>
      <div style={{ marginTop: 24 }}>
        <P2TextInput onBlur={props.handleSpouseIdFieldBlur} forceError={props?.forceError} disabled={props.disableFields} isError={!props.itemHoldingErrors?.spouse?.isValid} errorMsg={props.itemHoldingErrors?.spouse?.message} required value={props.item?.spouse?.toString()} name='name' label="Spouse's identification number" maxLength={256} placeholder={placeholder} type='text' onChange={handleSpouseIdChange} />
      </div>
    </>}
  </>
}

export default SpouseForm